var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4476 5.57771C12.9411 4.41358 12.0774 3.43365 10.9479 2.78156C8.07817 1.12471 4.40863 2.10796 2.75178 4.97772C1.09492 7.84747 2.07817 11.517 4.94793 13.1739C7.81769 14.8307 11.4872 13.8475 13.1441 10.9777C13.3589 10.6057 13.8345 10.4783 14.2065 10.693C14.5786 10.9078 14.706 11.3835 14.4912 11.7555C12.4048 15.3693 7.78392 16.6074 4.17015 14.521C0.556386 12.4346 -0.681782 7.8137 1.40463 4.19994C3.49104 0.586171 8.11194 -0.651996 11.7257 1.43441C12.862 2.09043 13.786 3.01204 14.4368 4.10446V1.33327C14.4368 0.903716 14.785 0.555493 15.2146 0.555493C15.6442 0.555493 15.9924 0.903716 15.9924 1.33327V6.35549C15.9924 6.57027 15.9053 6.76471 15.7646 6.90546C15.6238 7.04621 15.4294 7.13327 15.2146 7.13327H10.1924C9.76282 7.13327 9.4146 6.78505 9.4146 6.35549C9.4146 5.92594 9.76282 5.57771 10.1924 5.57771H13.4476Z",
    fill: "#151515"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.760e65c830a84e8a4e9f60a4c65cddf0.svg";
export { ForwardRef as ReactComponent };